import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import Box from "@mui/material/Box";
import {ImageViewWrapper, InnerImageViewer} from "./StyledComponents";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PermMediaIcon from '@mui/icons-material/PermMedia';


const ImageViewer = ({ToggleReplaceModal, imageSrc,setImageSrc, newInputHandler}) =>{
    const inputRef = useRef();
    const {activeObject} = useSelector((state) => state.canvas);
    const { isLoggedIn } = useSelector((state) => state.loginSlice);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    useEffect(()=>{
        if(activeObject && (activeObject.type === 'image')) {
            setImageSrc(activeObject.getSrc())
        }
        if(activeObject && activeObject?.type === 'group' || activeObject?.type === 'path') {
            setImageSrc(activeObject.originalSrc)
        }
    },[activeObject])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const uploadFile = () => {
        if (!isLoggedIn) {
            alert('Please login first')
            return;
        }
        inputRef.current.click();
        handleClose()
    };

    return(
        <Box sx={{padding:'1rem 0.25rem'}}>
            <ImageViewWrapper className="transition-all img-bg-gray">
                <img src={imageSrc} alt="" height='160px' width='100%' style={{objectFit:"contain"}}/>
                <InnerImageViewer className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-ui-overlay-01 space-y-1 opacity-0 invisible transition-all group-hover:opacity-100 group-hover:visible">
                    <span
                        className="img-replace-btn"
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                    >
                        {activeObject?.type === 'image' ? 'Replace' : 'Add Image'}
                    </span>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={()=>{
                            ToggleReplaceModal()
                            handleClose()
                        }}>
                            <ListItemIcon>
                                <PermMediaIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Stock Images</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={uploadFile}>
                            <ListItemIcon>
                                <CloudUploadIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>My Photos</ListItemText>
                        </MenuItem>
                    </Menu>
                    <input
                        ref={inputRef}
                        onChange={newInputHandler}
                        onClick={(e) => (e.target.value = null)}
                        multiple="multiple"
                        className="d-none"
                        type="file"
                        name="file"
                        accept="*"
                    />
                </InnerImageViewer>
            </ImageViewWrapper>
        </Box>
    )
}
export default ImageViewer